import { FC } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Modal } from "../../../Components/Modal";
import { Button } from "../../../Components/Button";
import { getDueDiligenceCaseStatusLabel } from "../../../Common/Types-DTOs/DueDiligence";

interface UnarchiveConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  caseName?: string;
  previousStatus?: string | null;
  hasFinalStatement?: boolean;
}

export const UnarchiveConfirmModal: FC<UnarchiveConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  caseName,
  previousStatus,
  hasFinalStatement
}) => {
  const { t } = useTranslation();
  const status = previousStatus
    ? getDueDiligenceCaseStatusLabel(previousStatus)
    : (hasFinalStatement
      ? t("dueDiligence.unarchiveConfirmModal.defaultStatusCompleted")
      : t("dueDiligence.unarchiveConfirmModal.defaultStatusInReview"));

  return (
    <Modal isOpen={isOpen}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '1.5rem',
        width: '100%',
        maxWidth: '500px'
      }}>
        <h2 style={{
          fontSize: '1.5rem',
          fontWeight: 600,
          color: '#111827',
          margin: 0
        }}>
          {t("dueDiligence.unarchiveConfirmModal.title")}
        </h2>
        <p style={{
          color: '#6B7280',
          lineHeight: 1.6,
          margin: 0
        }}>
          <Trans
            i18nKey="dueDiligence.unarchiveConfirmModal.message"
            values={{ caseName, status }}
            components={{ 1: <strong />, 2: <strong /> }}
          />
        </p>
        <div style={{ display: 'flex', gap: '1rem', flexDirection: 'column' }}>
          <Button
            onClick={onConfirm}
            style={{
              backgroundColor: '#3B82F6',
              color: '#ffffff',
              width: '100%'
            }}
          >
            {t("dueDiligence.unarchiveConfirmModal.confirmButton")}
          </Button>
          <p
            onClick={onClose}
            style={{
              textAlign: 'center',
              color: '#6B7280',
              cursor: 'pointer',
              margin: 0,
              padding: '0.5rem 0',
              transition: 'color 0.2s'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = '#111827';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = '#6B7280';
            }}
          >
            {t("dueDiligence.unarchiveConfirmModal.cancelButton")}
          </p>
        </div>
      </div>
    </Modal>
  );
};
